'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _components = {
	_$List: {
		displayName: 'List'
	},
	_$TreePicker: {
		displayName: 'TreePicker'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var List = (function (_React$Component) {
	_inherits(List, _React$Component);

	function List() {
		_classCallCheck(this, _List);

		_React$Component.apply(this, arguments);
	}

	List.prototype.flattenTree = function flattenTree(nodes) {
		var _this = this;

		var level = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
		var parentCollapsed = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

		var rows = [];
		nodes.forEach(function (item) {
			item.collapsed = _this.props.collapsed.indexOf(item.id) > -1;
			item.hide = parentCollapsed;
			item.level = level;
			rows.push(item);
			if (item.childs.length) {
				var subrows = _this.flattenTree(item.childs, level + 1, item.collapsed || item.hide);
				rows = rows.concat(subrows);
			}
		});
		return rows;
	};

	List.prototype.componentDidMount = function componentDidMount() {
		var id = this.props.value && this.props.value.get('id');
		if (id) {
			_reactDom2['default'].findDOMNode(this.refs[id]).focus();
		}
	};

	List.prototype.renderOption = function renderOption(item, index) {
		var _this2 = this;

		var optionClass = _classnames2['default']({
			'Dropdown-option': true,
			'is-selected': this.props.value && item.id == this.props.value.get('id'),
			'hide': item.hide
		});

		var ico = undefined;
		var collapsed = item.collapsed;
		if (item.childs.length) {
			if (!collapsed) {
				ico = _react2['default'].createElement('span', { onClick: function (e) {
						return _this2.props.onCollapse(e, true, item.id);
					}, style: { width: 8, cursor: 'pointer' }, className: 'fa fa-caret-down position-left' });
			} else {
				ico = _react2['default'].createElement('span', { onClick: function (e) {
						return _this2.props.onCollapse(e, false, item.id);
					}, style: { paddingLeft: 3, width: 8, cursor: 'pointer' }, className: 'fa fa-caret-right position-left' });
			}
		} else {
			ico = _react2['default'].createElement('span', { className: 'fa', style: { marginRight: 16 } });
		}

		return _react2['default'].createElement(
			'div',
			{ key: item.id,
				ref: item.id,
				style: { paddingLeft: item.level * 10 + 10 },
				className: optionClass,
				tabIndex: index,
				onClick: function () {
					return _this2.props.onSelect(_immutable2['default'].Map({ id: item.id, title: item.title }));
				} },
			ico,
			item.title
		);
	};

	List.prototype.render = function render() {
		var _this3 = this;

		var rows = this.flattenTree(this.props.tree).map(function (item, index) {
			return _this3.renderOption(item, index);
		});
		return rows.length ? _react2['default'].createElement(
			'div',
			null,
			rows
		) : _react2['default'].createElement(
			'div',
			{ className: 'Dropdown-noresults' },
			'Žádné záznamy k zobrazení'
		);
	};

	var _List = List;
	List = _wrapComponent('_$List')(List) || List;
	return List;
})(_react2['default'].Component);

var TreePicker = (function (_React$Component2) {
	_inherits(TreePicker, _React$Component2);

	_createClass(TreePicker, null, [{
		key: 'defaultProps',
		value: {
			controlClassName: 'Dropdown-control',
			menuClassName: 'Dropdown-menu',
			width: 'auto',
			dropdownWidth: '100%'
		},
		enumerable: true
	}]);

	function TreePicker(props) {
		_classCallCheck(this, _TreePicker);

		_React$Component2.call(this, props);
		this.state = {
			value: props.value,
			isOpen: false,
			collapsed: [],
			loaded: !!props.tree,
			tree: props.tree,
			pending: false
		};
		this.mounted = true;
		this.handleDocumentClick = this.handleDocumentClick.bind(this);
	}

	TreePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
		if (newProps.value !== this.state.value) {
			this.setState({ value: newProps.value });
		}
	};

	TreePicker.prototype.componentDidMount = function componentDidMount() {
		document.addEventListener('click', this.handleDocumentClick, false);
	};

	TreePicker.prototype.componentWillUnmount = function componentWillUnmount() {
		this.mounted = false;
		document.removeEventListener('click', this.handleDocumentClick, false);
	};

	TreePicker.prototype.handleMouseDown = function handleMouseDown(event) {
		var _this4 = this;

		if (event.type == 'mousedown' && event.button !== 0) return;
		event.stopPropagation();
		event.preventDefault();

		this.setState({
			isOpen: !this.state.isOpen
		}, function () {
			if (_this4.state.isOpen) {
				_this4.load();
			}
		});
	};

	TreePicker.prototype.setValue = function setValue(option) {
		var newState = {
			value: option,
			isOpen: false
		};
		this.fireChangeEvent(newState);
		this.setState(newState);
	};

	TreePicker.prototype.fireChangeEvent = function fireChangeEvent(newState) {
		if (newState.value !== this.state.value) {
			if (this.props.onChange) {
				this.props.onChange(newState.value);
			}
			if (this.props.onBlur) {
				this.props.onBlur(newState.value);
			}
		}
	};

	TreePicker.prototype.handleCollapse = function handleCollapse(e, collapse, id) {
		e.stopPropagation();

		var i = this.state.collapsed.indexOf(id);
		if (collapse) {
			if (i == -1) {
				this.state.collapsed.push(id);
			}
		} else {
			if (i != -1) {
				this.state.collapsed.splice(i, 1);
			}
		}
		this.setState({ collaped: this.state.collapsed });
	};

	TreePicker.prototype.buildMenu = function buildMenu() {
		var _this5 = this;

		if (this.state.loaded) {
			return _react2['default'].createElement(List, { tree: this.state.tree,
				collapsed: this.state.collapsed,
				onCollapse: function (e, status, item) {
					return _this5.handleCollapse(e, status, item);
				},
				onSelect: function (val) {
					return _this5.setValue(val);
				},
				value: this.state.value
			});
		} else {
			return _react2['default'].createElement(
				'div',
				{ className: 'Dropdown-noresults' },
				'Načítám data...'
			);
		}
	};

	TreePicker.prototype.handleDocumentClick = function handleDocumentClick(event) {
		if (this.mounted) {
			if (!_reactDom2['default'].findDOMNode(this).contains(event.target)) {
				this.setState({ isOpen: false });
			}
		}
	};

	TreePicker.prototype.load = function load() {
		var _this6 = this;

		if (!this.state.loaded) {
			this.setState({
				pending: true
			});
			this.props.getData(function (data) {
				_this6.setState({
					loaded: true,
					tree: data,
					pending: false
				});
			});
		}
	};

	TreePicker.prototype.handleReset = function handleReset(e) {
		e.stopPropagation();
		this.setValue(null);
	};

	TreePicker.prototype.render = function render() {
		var _this7 = this;

		var _props = this.props;
		var controlClassName = _props.controlClassName;
		var menuClassName = _props.menuClassName;

		var value = _react2['default'].createElement(
			'div',
			null,
			this.state.value ? _react2['default'].createElement(
				'div',
				null,
				_react2['default'].createElement('span', { className: 'reset icon-cross', onClick: function (e) {
						return _this7.handleReset(e);
					} }),
				this.state.value.get('title')
			) : _react2['default'].createElement(
				'span',
				{ className: 'placeholder' },
				this.props.placeholder
			)
		);
		var menu = this.state.isOpen ? _react2['default'].createElement(
			'div',
			{ className: menuClassName, style: { width: this.props.dropdownWidth } },
			this.buildMenu()
		) : null;

		var dropdownClass = _classnames2['default']({
			'Dropdown': true,
			'is-open': this.state.isOpen
		});

		return _react2['default'].createElement(
			'div',
			{ className: dropdownClass, style: { width: this.props.width } },
			_react2['default'].createElement(
				'div',
				{ className: controlClassName, onClick: this.handleMouseDown.bind(this) },
				value,
				_react2['default'].createElement('span', { className: 'Dropdown-arrow' })
			),
			menu
		);
	};

	var _TreePicker = TreePicker;
	TreePicker = _wrapComponent('_$TreePicker')(TreePicker) || TreePicker;
	return TreePicker;
})(_react2['default'].Component);

exports['default'] = TreePicker;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/TreePicker.js
 ** module id = 1045
 ** module chunks = 1
 **/